import { useState, type ReactNode } from 'react';
import { documentDansLaLangue, ouvrirDocumentLegal } from '../../utils/lienLegal';
import { t } from '../../i18n';

/**
 * Un lien vers un document legal, qui ne meurt jamais en silence.
 *
 * Si l'ouverture echoue — greffon absent, vue refusee, fenetre bloquee
 * par le navigateur — on ne laisse pas l'utilisateur devant un bouton
 * qui ne fait rien : l'adresse s'affiche, selectionnable, pour etre
 * copiee et ouverte ailleurs. C'est le minimum sur un document qu'on est
 * cense pouvoir lire avant d'accepter.
 */
export function LienLegal({
  url,
  children,
  className,
}: {
  url: string;
  children: ReactNode;
  className?: string;
}) {
  const [echec, setEchec] = useState(false);

  return (
    <>
      <button
        type="button"
        className={className ?? 'lien-legal'}
        onClick={() => {
          void ouvrirDocumentLegal(url).then((ouvert) => setEchec(!ouvert));
        }}
      >
        {children}
      </button>
      {echec && (
        <p className="lien-legal__secours">
          {t.legal.lien.impossible} <span>{documentDansLaLangue(url)}</span>
        </p>
      )}
    </>
  );
}
